import { CA, US } from "country-flag-icons/react/1x1";

const sizes = {
  sm: "h-3.5 w-3.5",
  md: "h-5 w-5",
} as const;

interface CountryFlagProps {
  countryCode: string;
  size?: keyof typeof sizes;
}

export function CountryFlag({ countryCode, size = "sm" }: CountryFlagProps) {
  const Flag = countryCode === "CA" ? CA : US;
  return (
    <span
      className={`inline-block overflow-hidden rounded-full border border-foreground/40 ${sizes[size]}`}
    >
      <Flag className="h-full w-full" />
    </span>
  );
}
